// GYM-596.2 — public-theme React Query hook.
// Used by ThemeProvider (member portal only).

import { useQuery } from "@tanstack/react-query";

import { getPublicTheme, type PublicTheme } from "@/lib/api/theme";

export const PUBLIC_THEME_KEY = ["publicTheme"] as const;

export function usePublicTheme() {
  return useQuery<PublicTheme>({
    queryKey: PUBLIC_THEME_KEY,
    queryFn: getPublicTheme,
    // Theme is fairly stable — cache for 5 min; don't hammer the API on
    // every portal page navigation.
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
